export const SETTINGS = {
  EXTERNAL_API_URL:
    window.location.hostname === "localhost"
      ? "http://localhost:8081/api/v1/"
      : "/api/v1/",
  CAPTCHA_API_URL: "https://captcha.e-soobrakaj.mk/2b296d444c/",
};
